import CityPageTemplate from "../city-template/CityPageTemplate";
import { carlsbadConfig } from "./data";

export default function CarlsbadPage() {
  return <CityPageTemplate config={carlsbadConfig} />;
}